import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PageService {
  constructor(
    private httpClient: HttpClient,

) { }

  getPage(pageId:string, forceRefresh:boolean):Observable<string> {
    return this.httpClient.get( environment.apiUrl + "/asset/content/" + pageId + ((forceRefresh)?"?refresh=true":""), {responseType: 'text'});
  }
}
